import { render, staticRenderFns } from "./PizzeriaItalia.vue?vue&type=template&id=07f60f41&scoped=true"
import script from "./PizzeriaItalia.vue?vue&type=script&lang=js"
export * from "./PizzeriaItalia.vue?vue&type=script&lang=js"
import style0 from "./PizzeriaItalia.vue?vue&type=style&index=0&id=07f60f41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f60f41",
  null
  
)

export default component.exports